import Firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAiVLIQ1IiOK4a1TyhBOXCO9MgUBdlQHD0",
    authDomain: "groupchrono2015.firebaseapp.com",
    databaseURL: "https://groupchrono2015.firebaseio.com",
    projectId: "groupchrono2015",
    storageBucket: "groupchrono2015.appspot.com",
    messagingSenderId: "575232303441",
    appId: "1:575232303441:web:affbaf69616783d0"
  };

const firebaseApp = Firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.database();
